import axios from "axios";
import { serverData, serviceUrls } from "./constant";

import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "./axiosComponent";

export const getCoursesList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/course/list",
    params: createQueryParams(data),
  });
};

export const getCourseDetails = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/course",
    params: createQueryParams(data),
  });
};
export const createCourse = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/course",
    data,
  });
};
export const updateCourse = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/course",
    data,
  });
};
export const updateCourseStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/course",
    params: createQueryParams(data),
  });
};
export const deleteCourse = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/course",
    params: createQueryParams({ entityId }),
  });
};

//Classes

export const getClassesList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/class/list",
    params: createQueryParams(data),
  });
};

export const getClassDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/class",
    params: createQueryParams({ entityId }),
  });
};

export const createClass = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/class",
    data,
  });
};

export const updateClass = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/class",
    data,
  });
};

export const updateClassStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/class",
    params: createQueryParams(data),
  });
};

export const deleteClass = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/class",
    params: createQueryParams({ entityId }),
  });
};

//tutor
export const getTutorList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/list",
    params: createQueryParams(data),
  });
};
export const getTutorDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor",
    params: createQueryParams({ entityId }),
  });
};
export const createTutor = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor",
    data,
  });
};
export const updateTutor = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor",
    data,
  });
};
export const updateTutorStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor",
    params: createQueryParams(data),
  });
};
export const deleteTutor = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor",
    params: createQueryParams({ entityId }),
  });
};

//tutor Subjects

export const selectSubjectToAddTutor = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/default/tutor/subject",
    params: createQueryParams(data),
  });
};
export const getTutorSubjectsList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/subject/list",
    params: createQueryParams(data),
  });
};
export const addSubjectToTutor = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/subject",
    data,
  });
};
export const removeSubjectFromTutor = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/subject",
    params: createQueryParams({ entityId }),
  });
};

//subject
export const getSubjectList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject/list",
    params: createQueryParams(data),
  });
};
export const getSubjectDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject",
    params: createQueryParams({ entityId }),
  });
};
export const createSubject = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject",
    data,
  });
};
export const updateSubject = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject",
    data,
  });
};
export const updateSubjectStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject",
    params: createQueryParams(data),
  });
};
export const deleteSubject = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject",
    params: createQueryParams({ entityId }),
  });
};

//tutors in subject
export const selectTutorToAddInSubject = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/default/subject/tutor",
    params: createQueryParams(data),
  });
};
export const deleteTutorFromSubject = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject/tutor",
    params: createQueryParams({ entityId }),
  });
};
export const addTutorToSubject = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/subject/tutor",
    data,
  });
};

//DIVISIONS
export const getDivisionList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/list",
    params: createQueryParams(data),
  });
};
export const getDivisionDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division",
    params: createQueryParams({ entityId }),
  });
};
export const createDivision = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/division",
    data,
  });
};
export const updateDivision = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/division",
    data,
  });
};
export const updateDivisionStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/division",
    params: createQueryParams(data),
  });
};
export const deleteDivision = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/division",
    params: createQueryParams({ entityId }),
  });
};

//DIVISION SECTIONS
export const getDivisionSectionList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/list",
    params: createQueryParams(data),
  });
};
export const getDivisionSectionDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section",
    params: createQueryParams({ entityId }),
  });
};
export const createDivisionSection = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section",
    data,
  });
};
export const updateDivisionSection = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section",
    data,
  });
};
export const updateDivisionSectionStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section",
    params: createQueryParams(data),
  });
};
export const deleteDivisionSection = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section",
    params: createQueryParams({ entityId }),
  });
};

//DIVISION SECTIONS SCHEDULE
export const getDivisionSectionScheduleList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule/list",
    params: createQueryParams(data),
  });
};
export const getDivisionSectionScheduleDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule",
    params: createQueryParams({ entityId }),
  });
};
export const createDivisionSectionSchedule = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule",
    data,
  });
};
export const updateDivisionSectionSchedule = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule",
    data,
  });
};
export const updateDivisionSectionScheduleStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule",
    params: createQueryParams(data),
  });
};
export const deleteDivisionSectionSchedule = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/schedule",
    params: createQueryParams({ entityId }),
  });
};

//DIVISION SECTION LECTURE
export const getDivisionSectionLectureList = async (data) => {
  console.log("see the data", data);
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lectures/list",
    params: createQueryParams(data),
  });
};
export const getDivisionSectionLectureDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lectures",
    params: createQueryParams({ entityId }),
  });
};
export const createDivisionSectionLecture = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lectures",
    data,
  });
};
export const updateDivisionSectionLecture = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lectures",
    data,
  });
};
export const updateDivisionSectionLectureStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lectures",
    params: createQueryParams(data),
  });
};
export const deleteDivisionSectionLecture = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/lecture",
    params: createQueryParams({ entityId }),
  });
};

//DIVISION SECTION Subject List
export const getDivisionSectionSubjectList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject/list",
    params: createQueryParams(data),
  });
};
export const getDivisionSectionSubjectDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject",
    params: createQueryParams({ entityId }),
  });
};
export const createDivisionSectionSubject = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject",
    data,
  });
};
export const updateDivisionSectionSubject = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject",
    data,
  });
};
export const updateDivisionSectionSubjectStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject",
    params: createQueryParams(data),
  });
};
export const deleteDivisionSectionSubject = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/division/section/subject",
    params: createQueryParams({ entityId }),
  });
};

//TUuto assignment
export const getTutorAssignmentList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/list",
    params: createQueryParams(data),
  });
};

export const getTutorAssignmentDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment",
    params: createQueryParams({ entityId }),
  });
};
export const createTutorAssignment = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment",
    data,
  });
};
export const updateTutorAssignment = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment",
    data,
  });
};
export const updateTutorAssignmentStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment",
    params: createQueryParams(data),
  });
};
export const deleteTutorAssignment = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment",
    params: createQueryParams({ entityId }),
  });
};

//Student
export const getStudentList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/student/list",
    params: createQueryParams(data),
  });
};

export const getStudentDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/student",
    params: createQueryParams({ entityId }),
  });
};
export const createStudent = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/student",
    data,
  });
};
export const updateStudent = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/student",
    data,
  });
};
export const updateStudentStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/student",
    params: createQueryParams(data),
  });
};
export const deleteStudent = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/student",
    params: createQueryParams({ entityId }),
  });
};

// Home work
export const getTutorHomeworkList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/list",
    params: createQueryParams(data),
  });
};
export const getTutorHomeworkDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework",
    params: createQueryParams({ entityId }),
  });
};
export const createTutorHomework = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework",
    data,
  });
};
export const updateTutorHomework = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework",
    data,
  });
};
export const updateTutorHomeworkStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework",
    params: createQueryParams(data),
  });
};
export const deleteTutorHomework = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework",
    params: createQueryParams({ entityId }),
  });
};

//Tutor Assignment review
export const getTutorAssignmentReviewList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review/list",
    params: createQueryParams(data),
  });
};
export const getTutorAssignmentReviewDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review",
    params: createQueryParams({ entityId }),
  });
};
export const createTutorAssignmentReview = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review",
    data,
  });
};
export const updateTutorAssignmentReview = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review",
    data,
  });
};
export const updateTutorAssignmentReviewStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review",
    params: createQueryParams(data),
  });
};
export const deleteTutorAssignmentReview = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/assignment/review",
    params: createQueryParams({ entityId }),
  });
};

//Tutor Homework review
export const getTutorHomeworkReviewList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review/list",
    params: createQueryParams(data),
  });
};
export const getTutorHomeworkReviewDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review",
    params: createQueryParams({ entityId }),
  });
};
export const createTutorHomeworkReview = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review",
    data,
  });
};
export const updateTutorHomeworkReview = async (data) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review",
    data,
  });
};
export const updateTutorHomeworkReviewStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review",
    params: createQueryParams(data),
  });
};
export const deleteTutorHomeworkReview = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/tutor/homework/review",
    params: createQueryParams({ entityId }),
  });
};


// Get Academic Year List
export const getAcademicYearList = async (data) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/year/list",
    params: createQueryParams(data),
  });
};
export const addAcademicYear = async (data) => {
  return await post({
    url: serviceUrls.ACADEMIC_SERVICE + "/year",
    data: data,
  });
};
export const updateAcademicYear = async (data, entityId) => {
  return await put({
    url: serviceUrls.ACADEMIC_SERVICE + "/year",
    data,
    params: createQueryParams({ entityId }),
  });
};
export const deleteAcademicYear = async (entityId) => {
  return await del({
    url: serviceUrls.ACADEMIC_SERVICE + "/year",
    params: createQueryParams({ entityId }),
  });
};
export const getAcademicYearDetails = async (entityId) => {
  return await get({
    url: serviceUrls.ACADEMIC_SERVICE + "/year",
    params: createQueryParams({ entityId }),
  });
};
export const updateAcademicYearStatus = async (data) => {
  return await patch({
    url: serviceUrls.ACADEMIC_SERVICE + "/year",
    params: createQueryParams(data),
  });
};



